import { render, staticRenderFns } from "./ChatFileUploadContainer.vue?vue&type=template&id=e60c5534"
import script from "./ChatFileUploadContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatFileUploadContainer.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports